import { Component } from 'react';
import { SECURE_AUTH_LOGIN_URL, SECURE_AUTH_PARTNER_BY_PASS } from './app-constants';
import { generateRandomString, saveCustomerCidnIfPresent } from './app-actions';

class AppSecureAuthRedirect extends Component {
  componentDidMount() {
    const hostname = window.location.hostname;
    saveCustomerCidnIfPresent();
    if (hostname.includes('localhost') === false && window.location.search.length < 2 && SECURE_AUTH_PARTNER_BY_PASS === false) {
      window.location = SECURE_AUTH_LOGIN_URL + generateRandomString(9); // appending a unique string for nonce each time;
    }
  }
  render() {
    return this.props.children;
  }
}

export default AppSecureAuthRedirect;
